import { render, staticRenderFns } from "./AddAccount.vue?vue&type=template&id=54fb5c6e&scoped=true&"
import script from "./AddAccount.vue?vue&type=script&lang=js&"
export * from "./AddAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddAccount.vue?vue&type=style&index=0&id=54fb5c6e&prod&lang=css&"
import style1 from "./AddAccount.vue?vue&type=style&index=1&id=54fb5c6e&prod&scoped=true&lang=css&"
import style2 from "./AddAccount.vue?vue&type=style&index=2&id=54fb5c6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fb5c6e",
  null
  
)

export default component.exports